import api from "../axios";
import type { DashboardsResponse } from "../types";

export const dashboardsApi = {
  baseKey: ["dashboards"],

  getDashboardsQueryOptions: (params?: {
    supplier_id?: string;
    offset?: number;
    limit?: number;
    sort_by?: string;
    order?: "ASC" | "DESC";
  }) => {
    const queryKey = [...dashboardsApi.baseKey, "list", params];

    return {
      queryKey,
      queryFn: async ({
        signal,
      }: {
        signal?: AbortSignal;
      }): Promise<DashboardsResponse> => {
        const url = params
          ? `/dashboards?${new URLSearchParams(params as Record<string, string>)}`
          : "/dashboards";
        const response = await api.get<DashboardsResponse>(url, { signal });
        return response.data;
      },
    };
  },
};
